<template>
<div class="form">
  <breadcrumb :items="[{ text: 'Produtos', to: '/produtos' }, { text: product ? product.name : 'Cadastrar produto', active: true }]" />
  <b-tabs small card ref="tabs" v-model="tab">
    <b-tab title="Apresentação">
      <b-form @submit.prevent="save" v-if="!isLoading">
        <b-form-group label="Em qual fase este produto está? *">
          <div class="row">
            <div v-for="(product_type, index) in tipos_de_produtos" :key="index" class="col-sm-4">
              <label class="choice" :class="{ active: form.product_type == product_type.value }">
                <input type="radio" v-model="form.product_type" :value="product_type.value" v-validate="'required'" name="product_type">
                <div class="icon">
                  <i :class="product_type.icon"></i>
                </div>
                <h6>{{product_type.text}}</h6>
              </label>
            </div>
          </div>
          <field-error :msg="veeErrors" field="product_type" />
        </b-form-group>
        <b-form-group label="Fornecedor *" v-if="!isA('supplier')">
          <form-entity-select type="suppliers" :form="form" field="supplier" :validate="'required'" />
        </b-form-group>
        <b-form-group label="Categorias *" class="checkbox-button">
          <b-form-checkbox-group  v-model="form.categories" :options="categorias_de_produtos" v-validate="'required'" name="categories" />
          <field-error :msg="veeErrors" field="categories" />
        </b-form-group>
        <b-form-group label="Nome do produto *">
          <b-form-input v-model="form.name" v-validate="'required'" name="name" description="Yuka" />
          <field-error :msg="veeErrors" field="name" />
        </b-form-group>
        <b-form-group label="Descrição *" description="Texto que irá aparecer na apresentação do produto.">
          <b-form-textarea v-model="form.description" v-validate="'required'" name="description" />
          <field-error :msg="veeErrors" field="description" />
        </b-form-group>
        <b-form-group label="História do produto" description="Descreva o histórico deste produto que aparecerá na apresentação">
          <form-editor :form="form" field="history" />
        </b-form-group>
        <b-form-group label="Certificações">
          <form-tags :form="form" field="certifications" :tags="certifications" />
        </b-form-group>
        <b-form-group label="Período de oferta">
          <form-months :form="form" field="seasonality" />
        </b-form-group>
        <pictures-upload :form="form" field="images" url="uploads/images" :multiple="true" />
        <div class="footer" v-if="tab == 0">
          <form-submit :errors="error" :sending="isSending" label="Continuar" />
        </div>
      </b-form>
    </b-tab>
    <b-tab v-if="product" title="Variações do produto">
      <div class="text-center">
        <router-link class="btn btn-primary btn-sm pull-right" :to="'/cadastrar-variacao-de-produto/?product=' + product._id">
          Cadastrar nova variação
        </router-link>
        <br>
        <br>
        <div class="alert alert-danger" v-if="error">
          {{error}}
        </div>
      </div>
      <div v-if="product.product_variations && product.product_variations.length">
        <table class="table b-table b-table-stacked-lg">
          <thead>
            <tr>
              <th></th>
              <th>Variação</th>
              <th>Preço final</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product_variation, index) in product.product_variations" :key="index">
              <td>
                <router-link :to="'/editar-variacao-de-produto/' + product_variation._id + '?product=' + product._id">
                  <product-image :product="product" :product_variation="product_variation" />
                </router-link>
              </td>
              <td>
                <router-link :to="'/editar-variacao-de-produto/' + product_variation._id + '?product=' + product._id">
                  {{product_variation.name}}
                </router-link>
                <br />
                <small>{{product_variation.description}}</small>
              </td>
              <td>
                {{product_variation.final_price | moeda}}
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <router-link class="btn btn-success" :to="'/cadastrar-oferta?product_variation=' + product_variation._id">
                    <i class="fa fa-plus"></i>  Oferta
                  </router-link>
                  <router-link class="btn btn-primary" :to="'/editar-variacao-de-produto/' + product_variation._id + '?product=' + product._id">
                    <i class="fa fa-pencil"></i>
                  </router-link>
                  <button class="btn btn-secondary" @click="removeVariation(product_variation._id)"> <i class="fa fa-close"></i> </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import axios from 'axios'
import FormSubmit from '@/components/FormSubmit'
import FormEntitySelect from '@/components/FormEntitySelect'
import FieldError from '@/components/FieldError'
import PicturesUpload from '@/components/PicturesUpload'
import FormEditor from '@/components/FormEditor';
import FormTags from '@/components/FormTags';
import FormMonths from '@/components/FormMonths';
import ProductImage from '@/components/ProductImage';
import tipos_de_produtos from '@/data/tipos-de-produtos.json'
import categorias_de_produtos from '@/data/categorias-de-produtos.json'


export default {

  name: 'ProductForm',
  data() {
    return {
      tipos_de_produtos: tipos_de_produtos,
      categorias_de_produtos: categorias_de_produtos,
      tab: 0,
      form: {
        supplier: null,
        product_type: '',
        categories: [],
        name: '',
        images: [],
        description: '',
        history: '',
        certifications: [],
        seasonality: [],
      },
      product: null,
      certifications: [],
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab || 1
    }
    if (this.isEditing()) {
      this.edit()
    }
    axios.get('products', {
      params: {
        select: 'certifications tags'
      }
    }).then(response => {
      response.data.forEach(product => {
        product.certifications.forEach(certification => {
          this.certifications.push(certification)
        })
      });
      this.certifications = this.certifications.filter((v, i, a) => a.findIndex(t => (t.text === v.text)) === i)
    }).catch(this.showError);
  },
  methods: {
    edit() {
      this.isLoading = true
      axios.get('products/' + this.$route.params.id, {
        params: {
          populate: 'users product_variations product_variations offers'
        }
      }).then(response => {
        this.apiDataToForm(this.form, response.data)
        this.product = response.data
        if (this.product.product_variations && this.product.product_variations.length > 0) {
          this.tab = this.$route.query.tab || 1
        }
        this.isLoading = false
      }).catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          if (this.isA('supplier')) {
            this.form.supplier = this.currentUser.supplier
          }
          axios({
            method: (this.isEditing() ? 'PUT' : 'POST'),
            url: (this.isEditing() ? 'products/' + this.$route.params.id : 'products'),
            data: this.form
          }).then(resp => {
            var product = resp.data
            if (product && product._id) {
              this.notify("Os dados foram salvos!")
              if (this.isEditing()) {
                window.scrollTo(0, 0);
                this.tab += 1
              } else {
                window.scrollTo(0, 0);
                this.$router.replace('/cadastrar-variacao-de-produto?product=' + product._id)
              }
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    isEditingProductVariation() {
      this.product_variation && this.product_variation._id
    },
    removeVariation(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios.delete('product_variations/' + id).then(() => {
          this.edit()
        }).catch(this.showError)
      }
    }
  },
  components: {
    FormSubmit,
    FormEntitySelect,
    FieldError,
    PicturesUpload,
    FormEditor,
    FormTags,
    FormMonths,
    ProductImage
  }
};
</script>
<style lang="sass" scoped>
  .choice
    text-align: center
    cursor: pointer
    border-radius: 15px
    padding: 15px
    display: block
    &.active
      color: #fff
      background-color: #215F60
    input
      display: none
    .fa
      font-size: 40px
      margin-bottom: 10px
</style>
